import React, { useState } from "react";
import Modal from "@mui/material/Modal";
import Typography from "@mui/material/Typography";
import Button from "../../base/reusables/button/Button";
import { useTranslation } from "react-i18next";
import './modal.css';  

interface ModalPropsDI {
  text: string;
  isOpen?: boolean;
  handleModalStatus?: (errorMode: boolean) => void;
  onClose?: ( ) => void;
  style?: any;
}



const CustomModal: React.FC<ModalPropsDI> = (props) => {
  const [modalOpen, setModalOpen] = useState(true);
  const { t } = useTranslation();

  React.useEffect(() => {
    // Update the document title using the browser API
    let isOpen = props.isOpen !== undefined ? props.isOpen : modalOpen;
    if (isOpen) {
      setTimeout(() => {
        let el = document.getElementById("modal-title");
        el?.focus();
      }, 0);
    }
  }, [props.isOpen, modalOpen]);

  const handleOpenStatus = () => {
    if (props.isOpen !== undefined && props.handleModalStatus !== undefined) {
      props.isOpen
        ? props.handleModalStatus(false)
        : props.handleModalStatus(true);
    } else {
      setModalOpen(!modalOpen);
    }
    props.onClose;
  };

  return (
    <Modal style={props.style}
      open={props.isOpen !== undefined ? props.isOpen : modalOpen}
      onClose={handleOpenStatus}
      className="modalBackdrop" 
      
    >
      <div  className={`paper paperPosition`}>  {/* Apply the CSS class */}
        <Typography
          variant="h6"
          id="modal-title"
          className="title"  // Apply the CSS class
          tabIndex={-1}
        >
          {props.text}
        </Typography>
        <Button
          aria-label={t("Custom-Modal-Ok")}
          onClick={handleOpenStatus}
          variant="empty"
        >
          {t("Custom-Modal-Ok")}
        </Button>
      </div>
    </Modal>
  );
};

export default CustomModal;
